import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';

import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DialogContainerComponent } from '@components/admin/configurator/dialog-container/dialog-container.component';
import { ModalActionButton } from '@models/types/components/ActionButton.type';

@Component({
    selector: 'app-modal-button-dialog',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DialogContainerComponent],
    templateUrl: './modal-button-dialog.component.html',
    styleUrl: './modal-button-dialog.component.css'
})
export class ModalButtonDialogComponent {
  private readonly dialogRef = inject(DialogRef);

  protected readonly data: {
    actionButton: ModalActionButton;
  } = inject(DIALOG_DATA);
}
